<template>
  <b-row>
    <b-col
      cols="12"
      class="ml-3"
      v-for="jobQuestionVariable in jobQuestion.jobQuestionVariables"
      :key="jobQuestionVariable.id"
    >
      <div>
        <label class="font-weight-bold">{{
          jobQuestionVariable.input_label
        }}</label>
        <b-form-radio-group
          class="mb-3"
          :checked="jobQuestionVariable.jobProfileQuestionResponses[0].value"
          @change="
            (checked) => onChangeHandler(checked, jobQuestionVariable.id)
          "
        >
          <b-form-radio v-for="i in 5" :key="i" :value="i">
            {{ i }}
          </b-form-radio>
        </b-form-radio-group>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { validationMixin } from 'vuelidate';
import SubFormValidationMethodsMixin from '@/mixins/SubFormValidationMethodsMixin';
export default {
  name: 'RatingPreferenceInput',
  mixins: [validationMixin, SubFormValidationMethodsMixin],
  props: {
    jobQuestion: {
      required: true,
    },
    forQuestionForm: {
      type: Boolean,
      default: false,
    },
  },
  validations: {
    rating: {},
  },
  methods: {
    onChangeHandler: function (checkedValue, variableId) {
      this.$emit('set-preference', variableId, checkedValue);
      this.$v.rating.$touch();
    },
  },
};
</script>

<style scoped></style>
